import { render } from "./WhatsappBtt.vue?vue&type=template&id=14972672&scoped=true"
import script from "./WhatsappBtt.vue?vue&type=script&lang=js"
export * from "./WhatsappBtt.vue?vue&type=script&lang=js"

import "./WhatsappBtt.vue?vue&type=style&index=0&id=14972672&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14972672"]])

export default __exports__